/* Web-Push im Shop (Roadmap 3.15 Paket B, Konzept docs/konzept_webpush_shop.md in mhsys, Abschnitt 6).
 *
 * Geladen aus layout/theme.liquid nur bei eingeschaltetem Schalter "Benachrichtigungen aus mhsys" oder im
 * Testmodus (?benachrichtigungen=test merkt sich das im eigenen Browser, ?benachrichtigungen=aus vergisst es).
 * Endpunkt: /apps/kunde?bereich=push&teil=... (App-Proxy "MHSys Kundeninhalte", mhsys extern/kundeninhalte/push).
 *
 * - Einladung nur an den Platzhaltern [data-mhsys-push-platz] (Schublade nach den Artikeln, Merkliste-Seite), nie
 *   beim Seitenaufruf; zweistufig: "Ja, gern" zeigt die Erklaerung, erst "Zulassen" fragt der Browser.
 *   Nur wenn der Browser Push kann, noch nicht gefragt wurde, kein eigenes Abo besteht und nicht in den letzten
 *   30 Tagen "x" gewaehlt wurde. iPhone im normalen Safari nie (Apple erlaubt Push dort nur als Web-App).
 * - Stille Uebernahme: ist die Erlaubnis schon erteilt UND besteht im Browser noch eine Subscription (die von PushOwl
 *   an /apps/pushowl/sdks/ oder unsere eigene), wird ohne Nachfrage abonniert (Quelle pushowl). Erlaubnis ohne
 *   Subscription ist keine Uebernahme - ein neues Abo gibt es nur per Klick. Nach "Ausschalten" (mhPushAus) nie.
 *   PushOwl ist seit 28.10.2026 deinstalliert, seine Worker-Registrierungen bleiben aber in den Browsern, bis der
 *   Browser sie einmal prueft (Geltungsbereich /apps/pushowl/, keine Pushes mehr - das kann dauern). Die Uebernahme
 *   brachte im Oktober rund 25 Abos am Tag, fast alle neuen Abonnenten - darum bleibt sie (Roadmap 6.15).
 * - Einmal am Tag "status" (haelt das Abo frisch, bemerkt ein stillgelegtes), einmal je Warenkorb das Attribut
 *   _push (und _push_klick nach einem Klick aus einer Nachricht) - mit Kopfzeile X-Mhsys-Warenkorb, damit die
 *   Schublade den Aufruf als eigenen erkennt und nicht neu laedt.
 * - Kontrollseite /pages/benachrichtigungen ([data-mhsys-push-kontrolle], sections/mhsys-benachrichtigungen.liquid) -
 *   seit 15.10.2026 auch als Overlay ueberall im Shop (assets/mhsys-popup.js): dort laufen die Skripte der geladenen
 *   Seite nicht, deshalb bindet dieses Skript die Kontrolle beim Ereignis mhsys:popup-inhalt selbst an den Inhalt.
 */
(function () {
  "use strict";
  if (window.mhsysPush) return;
  window.mhsysPush = true;

  var BASIS = "/apps/kunde?bereich=push&teil=";
  /* "Merkliste: wieder da" schickt mhsys nur angemeldeten Kunden (die Merkliste von Gaesten liegt nur im Browser,
     core/kundenpush.inc.php) - Gaesten wird es deshalb nicht versprochen (Roadmap 6.24, Inhaber 17.10.2026) */
  var KUNDE = !!(window.mhsysMerkCfg && window.mhsysMerkCfg.kunde);
  // Fassung des Einladungstexts unten - bei jeder Textaenderung hochzaehlen; Gaeste lesen die Fassung ohne Merkliste
  var TEXT_VERSION = KUNDE ? "2026-10-v3" : "2026-10-v3-gast";
  var TAG = 864e5;
  var n = navigator;
  var ios = /iPhone|iPad|iPod/.test(n.userAgent) || (n.platform === "MacIntel" && n.maxTouchPoints > 1);
  var webapp = (window.matchMedia && matchMedia("(display-mode: standalone)").matches) || n.standalone === true;
  var kann = "serviceWorker" in n && "PushManager" in window && "Notification" in window;
  var iphone = ios && !webapp;
  if (iphone) kann = false;

  var TEXTE = {
    warenkorb: "Sollen wir dir Bescheid geben, wenn dein Paket unterwegs ist?",
    merkliste: "Sollen wir dir Bescheid geben, wenn etwas von deiner Merkliste wieder da ist?",
    lang: "Wir schicken nur, was dich interessiert: dein Paket ist unterwegs" + (KUNDE ? ", etwas von deiner Merkliste ist wieder da" : "") +
      " – und ab und zu ein Angebot. Ausschalten geht jederzeit. Gleich fragt dein Browser – dort bitte „Zulassen“ tippen.",
  };

  function lesen(k) { try { return JSON.parse(localStorage.getItem(k) || "null"); } catch (e) { return null; } }
  function merken(k, v) { try { v === null ? localStorage.removeItem(k) : localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function heute() { return new Date().toISOString().slice(0, 10); }
  // Mit Zeitlimit (layout/theme.liquid, Roadmap 7.44): antwortet mhsys nicht, bleibt kein Knopf ewig gesperrt
  function holen(url, init) { return window.mhsysNetz ? window.mhsysNetz.holen(url, init) : fetch(url, init); }
  function senden(teil, daten) {
    return holen(BASIS + teil, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(daten || {}) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j.status_http = r.status; return j; }); });
  }
  function ereignis(art) { senden("ereignis", { art: art }).catch(function () {}); }
  function b64(p) { var b = new Uint8Array(p), t = ""; for (var i = 0; i < b.length; i++) t += String.fromCharCode(b[i]); return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); }
  function roh(s) { s = s.replace(/-/g, "+").replace(/_/g, "/"); s += "===".slice((s.length + 3) % 4); var b = atob(s), a = new Uint8Array(b.length); for (var i = 0; i < b.length; i++) a[i] = b.charCodeAt(i); return a; }
  function abo() { return lesen("mhPush"); }

  /* ---- Abonnieren (nach erteilter Erlaubnis) ---- */
  function registrierung() {
    return n.serviceWorker.register(BASIS + "sw.js").then(function (reg) {
      /* Der Geltungsbereich (/apps/) umfasst diese Seite nicht - serviceWorker.ready loeste nie auf. Deshalb auf die
         Aktivierung genau dieser Registrierung warten: subscribe() verlangt einen aktiven Worker. */
      return new Promise(function (ok, fehler) {
        /* Ein schon aktiver Worker genuegt (ein Update im Hintergrund stoert subscribe() nicht). Scheitert die
           Installation ("redundant"), nicht ewig warten - sonst passiert fuer den Nutzer "nichts". */
        if (reg.active) return ok(reg);
        var sw = reg.installing || reg.waiting;
        if (!sw) return ok(reg);
        sw.addEventListener("statechange", function () {
          if (sw.state === "activated") ok(reg);
          if (sw.state === "redundant") fehler(new Error("worker"));
        });
      });
    });
  }
  /* textVersion: Fassung des Texts, den der Kunde vor dem Klick gesehen hat (Bestellstatus-Seite: bs-unterwegs-1 ...) */
  function abonnieren(quelle, textVersion) {
    return Promise.all([registrierung(), holen(BASIS + "schluessel").then(function (r) { return r.json(); })])
      .then(function (e) {
        var reg = e[0], schluessel = roh(e[1].schluessel || "");
        return reg.pushManager.getSubscription().then(function (alt) {
          var neu = function () { return reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: schluessel }); };
          return alt ? neu().catch(function () { return alt.unsubscribe().then(neu); }) : neu();
        });
      })
      .then(function (sub) {
        return senden("abo", {
          endpoint: sub.endpoint,
          keys: { p256dh: b64(sub.getKey("p256dh")), auth: b64(sub.getKey("auth")) },
          quelle: quelle,
          text_version: textVersion || TEXT_VERSION,
          /* Kennung des vorigen Abos aus diesem Browser - der Server uebernimmt davon die Testgeraet-Markierung */
          vorher: lesen("mhPushVorher") || "",
        });
      })
      .then(function (j) {
        if (!j.ok || !j.kennung) throw new Error("abo");
        merken("mhPush", { kennung: j.kennung, stand: heute() });
        merken("mhPushVorher", j.kennung); // bleibt auch nach "Ausschalten" - fuer das naechste Einschalten
        merken("mhPushAus", null); // wer (wieder) einschaltet, hebt ein frueheres "Ausschalten" auf
        merken("mhPushKorb", null); // Abmelden hat die Aktivitaet beim Server geloescht - Warenkorb neu melden
        merken("mhPushAnsicht", null);
        merken("mhPushWk", null); // _push im Warenkorb gleich setzen
        warenkorbMerkmal();
        return j;
      });
  }
  /* Besteht an irgendeiner Worker-Registrierung dieser Domain eine Push-Subscription (PushOwl oder unsere)? */
  function bestehendeSubscription() {
    if (!n.serviceWorker.getRegistrations) return Promise.resolve(false);
    return n.serviceWorker.getRegistrations().then(function (regs) {
      return Promise.all(regs.map(function (r) { return r.pushManager ? r.pushManager.getSubscription().catch(function () { return null; }) : null; }));
    }).then(function (subs) { return subs.some(function (s) { return !!s; }); });
  }
  function erlaubnis() {
    /* Muss direkt im Klick laufen (Nutzeraktion); aeltere Safari kennen nur die Rueckruf-Form */
    return new Promise(function (ok) { var p = Notification.requestPermission(ok); if (p && p.then) p.then(ok); });
  }

  /* ---- Einladung ---- */
  function einladungErlaubt() {
    if (!kann || Notification.permission !== "default" || abo()) return false;
    var spaeter = lesen("mhPushSpaeter");
    return !(spaeter && Date.now() - spaeter < 30 * TAG);
  }
  function einladungenWeg() {
    document.querySelectorAll("[data-mhsys-push-platz]").forEach(function (p) { p.hidden = true; p.innerHTML = ""; });
  }
  function einladung(platz) {
    platz.setAttribute("data-mhsys-push-voll", "");
    if (!einladungErlaubt()) return;
    /* Auf der Merkliste nur fuer angemeldete Kunden (nur sie bekommen "wieder da") und nur, wenn etwas darauf steht */
    if (platz.getAttribute("data-mhsys-push-platz") === "merkliste") {
      if (!KUNDE) return;
      var liste = lesen("mhsysMerkliste");
      if (!liste || !liste.length) return;
    }
    var glocke = '<svg class="mhsys-icon" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M12 2.5a1.3 1.3 0 0 1 1.3 1.3v.6a6.2 6.2 0 0 1 4.9 6.1v3.9l1.6 2.3c.5.7 0 1.6-.8 1.6H5c-.8 0-1.3-.9-.8-1.6l1.6-2.3v-3.9a6.2 6.2 0 0 1 4.9-6.1v-.6A1.3 1.3 0 0 1 12 2.5Zm-2.6 17h5.2a2.6 2.6 0 0 1-5.2 0Z"/></svg>';
    platz.innerHTML = '<div class="mhsys-push" role="group" aria-label="Benachrichtigungen">' + glocke +
      '<span class="mhsys-push__text" data-push-text></span>' +
      '<button type="button" class="mhsys-push__ja" data-push-ja>Ja, gern</button>' +
      '<button type="button" class="mhsys-push__zu" data-push-zu aria-label="Später">×</button></div>';
    platz.querySelector("[data-push-text]").textContent = TEXTE[platz.getAttribute("data-mhsys-push-platz")] || TEXTE.warenkorb;
    platz.hidden = false;
    try { if (!sessionStorage.getItem("mhPushGezeigt")) { sessionStorage.setItem("mhPushGezeigt", "1"); ereignis("einladung_gezeigt"); } } catch (e) {}
  }
  function platzieren() {
    document.querySelectorAll("[data-mhsys-push-platz]:not([data-mhsys-push-voll])").forEach(einladung);
  }
  function hinweis(box, html) { box.innerHTML = '<p class="mhsys-push__fertig">' + html + "</p>"; }

  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-push-ja],[data-push-zu],[data-push-zulassen]");
    if (!t) return;
    var box = t.closest(".mhsys-push");
    if (t.hasAttribute("data-push-zu")) {
      merken("mhPushSpaeter", Date.now());
      ereignis("spaeter");
      einladungenWeg();
      return;
    }
    if (t.hasAttribute("data-push-ja")) {
      ereignis("ja");
      box.classList.add("mhsys-push--offen");
      box.querySelector("[data-push-text]").innerHTML = "<strong>Magst du Bescheid kriegen?</strong>";
      t.textContent = "Zulassen";
      t.removeAttribute("data-push-ja");
      t.setAttribute("data-push-zulassen", "");
      var lang = document.createElement("p");
      lang.className = "mhsys-push__lang";
      lang.textContent = TEXTE.lang + " ";
      var link = document.createElement("a");
      link.href = "/policies/privacy-policy";
      link.textContent = "Was wir speichern";
      lang.appendChild(link);
      box.appendChild(lang);
      t.focus();
      return;
    }
    /* Zulassen: die Browser-Nachfrage im selben Klick */
    t.disabled = true;
    erlaubnis().then(function (p) {
      if (p === "granted") {
        ereignis("browser_erlaubt");
        // frist wie auf der Kontrollseite: haengt mhsys (Worker-Skript, Schluessel), kommt der Hinweis statt nichts
        return frist(abonnieren("einladung"), 20000).then(function () {
          hinweis(box, "Passt! Gleich kommt eine kurze Willkommens-Nachricht.");
        });
      }
      if (p === "denied") {
        ereignis("browser_abgelehnt");
        hinweis(box, 'Schade. Einschalten geht jederzeit auf der Seite <a href="/pages/benachrichtigungen">Benachrichtigungen</a>.');
        return;
      }
      t.disabled = false; // Nachfrage weggeklickt - nochmal moeglich
    }).catch(function () {
      hinweis(box, "Das hat gerade nicht geklappt – bitte versuch es in ein paar Minuten noch einmal.");
    });
  });

  /* ---- Warenkorb-Merkmal _push (einmal je Warenkorb) ---- */
  function warenkorbToken() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? decodeURIComponent(m[1]).split("?")[0] : "";
  }
  function warenkorbMerkmal() {
    var a = abo(), token = warenkorbToken();
    if (!a || !token || lesen("mhPushWk") === token) return;
    var merkmale = { _push: a.kennung };
    var klick = lesen("mhPushKlick");
    /* 14 Tage nach dem Klick zaehlt eine Bestellung als "nach Klick" (Roadmap 3.40, Entscheidung des Inhabers; bis 25.09.2026 7) */
    if (klick && Date.now() - klick.zeit < 14 * TAG) merkmale._push_klick = klick.s;
    merken("mhPushWk", token);
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Mhsys-Warenkorb": "1" },
      body: JSON.stringify({ attributes: merkmale }),
    }).catch(function () { merken("mhPushWk", null); });
  }

  /* ---- Aktivitaet fuer Warenkorb-Erinnerung und "Angesehenes Produkt" (Paket D, mhsys teil=aktivitaet) ----
     Nur mit gemerktem eigenem Abo und nie nach "Ausschalten". Der Server merkt sich nur etwas, wenn das Abo aktiv ist
     und das Thema "Angebote & Neuheiten" hat - hier wird nichts entschieden, nur gemeldet. Scheitert ein Aufruf,
     merkt die Seite davon nichts (frist + catch). */
  function aktivitaetAbo() {
    var a = abo();
    return kann && a && a.kennung && !lesen("mhPushAus") ? a : null;
  }
  function warenkorbMelden() {
    var a = aktivitaetAbo();
    if (!a) return;
    frist(fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }), 8000)
      .then(function (korb) {
        var positionen = (korb.items || []).map(function (i) { return { p: String(i.product_id), v: String(i.variant_id), q: i.quantity }; });
        /* Nur einen neuen Stand melden - sonst meldet jeder Seitenaufruf denselben Warenkorb */
        var stand = positionen.map(function (x) { return x.v + ":" + x.q; }).sort().join(",");
        if (lesen("mhPushKorb") === stand) return;
        return frist(senden("aktivitaet", { kennung: a.kennung, art: "warenkorb", positionen: positionen }), 8000)
          .then(function () { merken("mhPushKorb", stand); });
      })
      .catch(function () {});
  }
  function produktId() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var id = m && m.product && m.product.id ? String(m.product.id) : "";
    if (!id) {
      var el = document.querySelector("[data-mhsys-produkt-id]");
      id = el ? String(el.getAttribute("data-mhsys-produkt-id") || "") : "";
    }
    return /^[1-9][0-9]{0,19}$/.test(id) ? id : "";
  }
  function ansichtMelden() {
    var a = aktivitaetAbo(), id = produktId();
    if (!a || !id) return;
    /* Je Produkt hoechstens einmal am Tag melden; der Merker behaelt nur Eintraege von heute */
    var gesehen = lesen("mhPushAnsicht") || {};
    if (gesehen[id] === heute()) return;
    frist(senden("aktivitaet", { kennung: a.kennung, art: "ansicht", produkt: id }), 8000)
      .then(function () {
        var neu = {};
        Object.keys(gesehen).forEach(function (k) { if (gesehen[k] === heute()) neu[k] = gesehen[k]; });
        neu[id] = heute();
        merken("mhPushAnsicht", neu);
      })
      .catch(function () {});
  }

  /* ---- Kontrollseite ---- */
  /* Ein Versprechen mit Frist: kommt nach ms nichts, gilt es als gescheitert - der Nutzer sieht dann eine Meldung
     statt eines Knopfs, bei dem "nichts passiert". */
  function frist(versprechen, ms) {
    return new Promise(function (ok, fehler) {
      var uhr = setTimeout(function () { fehler(new Error("frist")); }, ms);
      versprechen.then(function (w) { clearTimeout(uhr); ok(w); }, function (e) { clearTimeout(uhr); fehler(e); });
    });
  }

  /* Anleitung je Geraet (15.10.2026): die Klappe des eigenen Geraets nach vorn, offen und mit "Dein Gerät" - einmal je
     Wurzel, vor dem ersten Zustand, damit nichts umspringt (im Overlay laeuft das noch vor dem ersten Bild) */
  var GERAET = ios ? "iphone" : /Android/i.test(n.userAgent) ? "android" : "rechner";
  function anleitungOrdnen(wurzel) {
    var liste = wurzel.querySelector("[data-push-geraete]");
    var deins = liste && liste.querySelector('[data-push-geraet="' + GERAET + '"]');
    if (!deins || deins.hasAttribute("data-push-deins-gesetzt")) return;
    deins.setAttribute("data-push-deins-gesetzt", "");
    liste.insertBefore(deins, liste.firstChild);
    deins.open = true;
    var marke = deins.querySelector("[data-push-deins]");
    if (marke) marke.hidden = false;
  }

  function kontrolle(wurzel) {
    anleitungOrdnen(wurzel);
    var zustand = function (name) {
      wurzel.querySelectorAll("[data-push-zustand]").forEach(function (z) { z.hidden = z.getAttribute("data-push-zustand") !== name; });
      /* Wer schon Nachrichten bekommt, braucht keine Anleitung mehr */
      var anleitung = wurzel.querySelector("[data-push-anleitung]");
      if (anleitung) anleitung.hidden = name === "aktiv" || name === "laden";
    };
    var meldung = function (text) { var m = wurzel.querySelector("[data-push-meldung]"); if (m) { m.textContent = text; m.hidden = !text; } };
    var aus = function () { zustand("aus"); };
    var FEHLER = "Das hat leider nicht geklappt. Lade die Seite neu und versuch es noch einmal.";

    /* Welcher Zustand gilt - beim Oeffnen und nach jeder Aktion. Haengt KEINE Handler an (die kommen einmal, unten). */
    function anzeigen() {
      if (iphone) return zustand("iphone");
      if (!kann) return zustand("kann-nicht");
      if (Notification.permission === "denied") return zustand("blockiert");
      var a = abo();
      if (!a) return aus();
      frist(senden("status", { kennung: a.kennung }), 10000).then(function (j) {
        if (!j.ok || j.status !== "aktiv") { merken("mhPush", null); return aus(); }
        zustand("aktiv");
        var themen = (j.themen || "").split(",");
        wurzel.querySelectorAll("[data-push-thema]").forEach(function (k) { k.checked = themen.indexOf(k.value) !== -1; });
      }).catch(aus);
    }
    anzeigen();
    /* Bei jedem Aufruf der Kontrollseite den Worker auf eine neue Fassung pruefen - so genuegt nach einer Aenderung
       am Worker ein Neuladen dieser Seite, ohne Aus- und Einschalten (das kann ein neues Abo erzeugen und die
       Testgeraet-Markierung kosten) */
    if (kann && n.serviceWorker.getRegistration) {
      n.serviceWorker.getRegistration(BASIS + "sw.js").then(function (reg) { return reg && reg.update(); }).catch(function () {});
    }

    /* Handler genau einmal - bis 22.09.2026 kamen sie erst NACH dem "if (!a) return aus();" dazu: ohne gemerktes Abo
       (frischer Besuch, nach "Ausschalten") hatte "Einschalten" gar keinen Handler, der Klick tat nichts. */
    if (wurzel.getAttribute("data-mhsys-push-gebunden")) return;
    wurzel.setAttribute("data-mhsys-push-gebunden", "");

    wurzel.addEventListener("change", function (e) {
      if (!e.target.matches("[data-push-thema]")) return;
      var gewaehlt = [].slice.call(wurzel.querySelectorAll("[data-push-thema]:checked")).map(function (k) { return k.value; });
      if (!gewaehlt.length) { e.target.checked = true; return meldung("Mindestens ein Thema bleibt an – sonst bitte „Ausschalten“."); }
      var a = abo();
      if (!a) return anzeigen();
      frist(senden("status", { kennung: a.kennung, themen: gewaehlt.join(",") }), 10000)
        .then(function (j) { meldung(j.ok ? "Gespeichert." : FEHLER); }, function () { meldung(FEHLER); });
    });
    wurzel.addEventListener("click", function (e) {
      var t = e.target.closest("[data-push-aktion]");
      if (!t) return;
      var art = t.getAttribute("data-push-aktion");
      var a = abo();
      if (art === "probe") {
        if (!a) return anzeigen();
        frist(senden("probe", { kennung: a.kennung }), 10000).then(function (j) {
          meldung(j.ok ? "Probe-Nachricht ist unterwegs." : j.fehler === "grenze" ? "Heute sind schon drei Proben rausgegangen." : FEHLER);
        }, function () { meldung(FEHLER); });
      } else if (art === "aus") {
        /* Merken, dass hier bewusst ausgeschaltet wurde: die Browser-Erlaubnis bleibt "granted", und ohne diesen
           Merker hielte der naechste Seitenaufruf das fuer eine stille PushOwl-Uebernahme und abonnierte neu -
           das Ausschalten hielte keine zwei Minuten (Test des Inhabers, 22.09.2026). */
        merken("mhPushAus", Date.now());
        t.disabled = true;
        meldung("Einen Moment …");
        frist(n.serviceWorker.getRegistration(BASIS + "sw.js").then(function (reg) { return reg && reg.pushManager.getSubscription(); })
          .then(function (sub) { return sub && sub.unsubscribe(); }), 10000)
          .catch(function () {})
          .then(function () { return a ? frist(senden("status", { kennung: a.kennung, aktion: "abmelden" }), 10000) : null; })
          .then(function () { merken("mhPush", null); meldung("Ausgeschaltet."); aus(); },
                function () { merken("mhPush", null); meldung("Auf diesem Gerät ausgeschaltet – die Abmeldung bei uns holen wir beim nächsten Besuch nach."); aus(); })
          .then(function () { t.disabled = false; });
      } else if (art === "ein") {
        t.disabled = true;
        meldung("Einen Moment …");
        erlaubnis().then(function (p) {
          if (p === "denied") { meldung(""); return zustand("blockiert"); }
          if (p !== "granted") { meldung("Dein Browser hat nicht zugelassen – tippe noch einmal auf „Einschalten“ und dann auf „Zulassen“."); return; }
          return frist(abonnieren("kontrollseite"), 20000).then(function () {
            meldung("Eingeschaltet – gleich kommt eine kurze Willkommens-Nachricht.");
            anzeigen();
          });
        }).catch(function () { meldung(FEHLER); }).then(function () { t.disabled = false; });
      }
    });
  }

  /* ---- Schnittstelle fuer andere Seiten (Roadmap 3.41 D: Push-Hinweis auf der Bestellstatus-Seite) ----
     Nur lesen und abonnieren - Texte, Zustaende und die Bindung an eine Bestellung entscheidet die Seite selbst.
     Die Seite kann vor diesem Skript laufen (beide defer, Bestellstatus steht weiter oben im Kopf; im Testmodus
     kommt dieses Skript dynamisch): sie wartet dann auf "mhsys:push-bereit". */
  window.mhsysPush = {
    kann: kann,
    iphone: iphone,
    abo: abo,
    ausgeschaltet: function () { return !!lesen("mhPushAus"); },
    erlaubnis: erlaubnis,
    abonnieren: abonnieren,
  };
  document.dispatchEvent(new CustomEvent("mhsys:push-bereit"));

  /* ---- Start ---- */
  /* Im Testmodus wird das Skript dynamisch eingefuegt (layout/theme.liquid) - dann gilt defer nicht, und es kann
     laufen, bevor der Body (Schublade, Platzhalter) steht. Deshalb erst nach dem Parsen starten. */
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  function start() {
  var mhpush = new URLSearchParams(location.search).get("mhpush");
  if (mhpush) { merken("mhPushKlick", { s: mhpush, zeit: Date.now() }); merken("mhPushWk", null); }

  var a = abo();
  /* Wer schon vor diesem Merker ein Abo hatte: die jetzige Kennung als "vorige" merken */
  if (a && a.kennung && !lesen("mhPushVorher")) merken("mhPushVorher", a.kennung);
  if (kann && Notification.permission === "granted" && !a && !lesen("mhPushAus")) {
    /* Stille Uebernahme (Konzept 5.1): nur wenn im Browser noch eine Subscription besteht - PushOwls Worker liegt
       auf derselben Domain, getRegistrations() findet ihn. Erlaubnis allein reicht nicht (Website-Daten geloescht,
       frueher ausgeschaltet): dann bleibt es beim Klick. Nicht nach "Ausschalten" (mhPushAus) - das muss halten. */
    bestehendeSubscription().then(function (ja) { if (ja) return abonnieren("pushowl"); }).catch(function () {});
  } else if (a && a.stand !== heute()) {
    senden("status", { kennung: a.kennung }).then(function (j) {
      if (j.status_http === 404 || (j.ok && j.status !== "aktiv")) merken("mhPush", null);
      else if (j.ok) merken("mhPush", { kennung: a.kennung, stand: heute() });
    }).catch(function () {});
    /* Einmal am Tag den Worker auf eine neue Fassung pruefen - sein Geltungsbereich (/apps/) umfasst die Shop-Seiten
       nicht, der Browser prueft ihn also nicht beim Seitenaufruf von selbst */
    if (kann && n.serviceWorker.getRegistration) {
      n.serviceWorker.getRegistration(BASIS + "sw.js").then(function (reg) { return reg && reg.update(); }).catch(function () {});
    }
  }
  warenkorbMerkmal();
  document.addEventListener("mhsys:warenkorb-geaendert", warenkorbMerkmal);
  /* Paket D: Warenkorb-Stand und Produktansicht. /cart.js beim Laden nur einmal je Sitzung und erst, wenn der
     Browser Luft hat - sonst nur, wenn die Schublade eine Aenderung meldet (Auflage MASTER, 22.09.2026) */
  document.addEventListener("mhsys:warenkorb-geaendert", warenkorbMelden);
  if (aktivitaetAbo()) {
    var spaeter = window.requestIdleCallback || function (f) { setTimeout(f, 2000); };
    spaeter(function () {
      ansichtMelden();
      var sitzung = null;
      try { sitzung = sessionStorage.getItem("mhPushKorbSitzung"); } catch (e) {}
      if (!sitzung) {
        try { sessionStorage.setItem("mhPushKorbSitzung", "1"); } catch (e) {}
        warenkorbMelden();
      }
    });
  }

  var k = document.querySelector("[data-mhsys-push-kontrolle]");
  if (k) kontrolle(k);
  /* Die Kontrollseite als Overlay (assets/mhsys-popup.js): derselbe Ablauf am geladenen Inhalt - Erlaubnis im Klick,
     Abo mit Quelle "kontrollseite", Themen, Probe, Ausschalten. Jedes Oeffnen bringt neuen Inhalt, also neu binden. */
  document.addEventListener("mhsys:popup-inhalt", function (e) {
    var w = e.detail && e.detail.wurzel;
    var kw = w && w.querySelector && w.querySelector("[data-mhsys-push-kontrolle]");
    if (kw) kontrolle(kw);
  });

  platzieren();
  /* Die Schublade setzt ihren Inhalt bei jedem Neurendern neu (replaceChildren an [data-wk-inhalt]) - dann den neuen
     Platzhalter fuellen. Beobachtet wird nur die direkte Kinderliste; das Fuellen selbst aendert sie nicht (keine
     Schleife), und data-mhsys-push-voll verhindert doppeltes Fuellen. */
  document.querySelectorAll("[data-wk-inhalt]").forEach(function (inhalt) {
    new MutationObserver(function () { platzieren(); warenkorbMerkmal(); }).observe(inhalt, { childList: true });
  });
  }
})();
